import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQAccordion({ items, testid = "faq-accordion" }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={testid}>
      {items.map((item, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-b border-navy-100">
          <AccordionTrigger
            className="text-left text-lg font-semibold text-navy py-5 min-h-[56px] hover:text-gold-dark transition-colors [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-gold-dark"
            data-testid={`${testid}-q-${i}`}
          >
            {item.q}
          </AccordionTrigger>
          <AccordionContent className="text-mutedink text-base leading-relaxed pb-5" data-testid={`${testid}-a-${i}`}>
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
